import service from '@/plugins/service'
import { createFormData } from '@/plugins/formData'

const base = '/device'

export const getDeviceList = time => {
  const data = createFormData({ time })
  return service({
    url: `${base}/unRegMachine/list`,
    method: 'post',
    data
  })
}

export const getDeviceDetail = batch => {
  const data = createFormData({ batch })
  return service({
    url: `${base}/unRegMachine/info`,
    method: 'post',
    data
  })
}

export const getLGJList = time => {
  const data = createFormData({ time })
  return service({
    url: `${base}/unRegMachine/lgj/list`,
    method: 'POST',
    data
  })
}

export const getDtuCode = machineId => {
  const data = createFormData({ machineId })
  return service({
    url: `${base}/unRegMachine/info/dtuCode`,
    method: 'POST',
    data
  })
}